/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The calendar platform where this connection was established. Either 'google' for Google Calendar or 'microsoft' for Microsoft Outlook/365
 */
export type CreateCalendarConnectionResponseInputDataCalendarPlatform =
  (typeof CreateCalendarConnectionResponseInputDataCalendarPlatform)[keyof typeof CreateCalendarConnectionResponseInputDataCalendarPlatform]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCalendarConnectionResponseInputDataCalendarPlatform = {
  google: "google",
  microsoft: "microsoft"
} as const
